// extracted by mini-css-extract-plugin
export default {"center":"LatestPhones_center__rGIL3"};